/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
 */
export interface CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    external_ehr_document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    relation_type?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    relation_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument
     */
    created_at?: string;
}


/**
 * @export
 */
export const CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum = {
    Document: 'screener_document',
    AdditionalDocument: 'screener_additional_document',
    GeneratedDocument: 'screener_generated_document'
} as const;
export type CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum = typeof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum[keyof typeof CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentRelationTypeEnum];


/**
 * Check if a given object implements the CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument interface.
 */
export function instanceOfCreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json: any): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    return CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'external_ehr_document_id': !exists(json, 'external_ehr_document_id') ? undefined : json['external_ehr_document_id'],
        'relation_type': !exists(json, 'relation_type') ? undefined : json['relation_type'],
        'relation_id': !exists(json, 'relation_id') ? undefined : json['relation_id'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(value?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'type': value.type,
        'external_ehr_document_id': value.external_ehr_document_id,
        'relation_type': value.relation_type,
        'relation_id': value.relation_id,
        'created_at': value.created_at,
    };
}

